import { gql } from '@apollo/client';

const subscriptionFragment = gql`
  fragment SubscriptionFields on SubscriptionPlan {
    id
    planDefinitionId
    planName
    tier
    billingInterval
    monthlyRate
    cardApplicationFeeRate
    achApplicationFeeRate
    stripeSourceId
    startDate
    endDate
    stripeSubscriptionId
    createdAt
    updatedAt
    status
    discount
    notes
  }
`;

const venueTierTrialFragment = gql`
  fragment VenueTierTrialFields on VenueTierTrial {
    id
    trialTier
    originalTier
    status
    startDate
    endDate
    grantedBy
    notes
    createdAt
    updatedAt
  }
`;

export const adminVenueQuery = gql`
  query AdminVenue($id: ID!) {
    adminVenue(id: $id) {
      id
      name
      slug
      timezone
      email
      discardedAt
      trialEndDate
      featureScope {
        basicFeaturesEnabled
        proFeaturesEnabled
        premiumFeaturesEnabled
        enterpriseFeaturesEnabled
      }
      subscription {
        ...SubscriptionFields
      }
      upcomingSubscription {
        ...SubscriptionFields
      }
      addOnPlans {
        id
        status
        addOnDefinition {
          id
          name
          slug
          monthlyRate
          annualRate
          trialDays
        }
        discount
        startDate
        endDate
        trialEndsAt
        nextBillingDate
        lastBillingDate
        effectiveMonthlyRate
        effectiveAnnualRate
        active
        trialing
        trialExpired
        stripeSubscriptionId
        stripeSubscriptionItemId
      }
      customerStartedAt
      achEnabled
      liveAvailability
      defaultPaymentProvider
      paymentsEnabled
      stripeAccount {
        id
        name
        stripeAccountId
        createdAt
      }
      websiteUrl
      users(limit: 100) {
        id
        role
        email
        firstName
        lastName
        magicLoginLink
      }
      organization {
        id
        name
        hubspotDealId
      }
      suspicious
      featureFlags
      squareLocationId
      squareAccount {
        id
        squareMerchantId
        createdAt
      }
      googlePlaceInfo {
        id
        placeId
      }
      planSet {
        id
        name
      }
      opentableRestaurantId
      opentableConnected
      opentableCustomInstructions
      opentableSyncTriggerStatus
      activePlanTierTrial {
        ...VenueTierTrialFields
      }
      planTierTrialHistory {
        ...VenueTierTrialFields
      }
    }
    adminPlanSets {
      id
      name
    }
  }
  ${subscriptionFragment}
  ${venueTierTrialFragment}
`;

export const subscriptionHistoryQuery = gql`
  query SubscriptionHistory($venueId: ID!) {
    subscriptionHistory(venueId: $venueId) {
      ...SubscriptionFields
    }
  }
  ${subscriptionFragment}
`;

export const removeVenueMutation = gql`
  mutation RemoveVenue($input: RemoveVenueInput!) {
    removeVenue(input: $input) {
      venue {
        id
      }
      errors {
        message
      }
    }
  }
`;

export const disconnectStripeAccountMutation = gql`
  mutation DisconnectStripeAccount($input: DisconnectStripeAccountInput!) {
    disconnectStripeAccount(input: $input) {
      venue {
        id
        stripeAccount {
          id
          name
          stripeAccountId
        }
      }
      errors {
        message
      }
    }
  }
`;

export const adminStartPlanTierTrialMutation = gql`
  mutation AdminStartPlanTierTrial($input: AdminStartPlanTierTrialInput!) {
    adminStartPlanTierTrial(input: $input) {
      adminVenue {
        id
        subscription {
          ...SubscriptionFields
        }
        activePlanTierTrial {
          ...VenueTierTrialFields
        }
        planTierTrialHistory {
          ...VenueTierTrialFields
        }
      }
      errors {
        message
      }
    }
  }
  ${subscriptionFragment}
  ${venueTierTrialFragment}
`;

export const adminExtendPlanTierTrialMutation = gql`
  mutation AdminExtendPlanTierTrial($input: AdminExtendPlanTierTrialInput!) {
    adminExtendPlanTierTrial(input: $input) {
      adminVenue {
        id
        activePlanTierTrial {
          ...VenueTierTrialFields
        }
        planTierTrialHistory {
          ...VenueTierTrialFields
        }
      }
      errors {
        message
      }
    }
  }
  ${venueTierTrialFragment}
`;

export const adminCancelPlanTierTrialMutation = gql`
  mutation AdminCancelPlanTierTrial($input: AdminCancelPlanTierTrialInput!) {
    adminCancelPlanTierTrial(input: $input) {
      adminVenue {
        id
        activePlanTierTrial {
          ...VenueTierTrialFields
        }
        planTierTrialHistory {
          ...VenueTierTrialFields
        }
      }
      errors {
        message
      }
    }
  }
  ${venueTierTrialFragment}
`;

export const adminDeletePlanTierTrialMutation = gql`
  mutation AdminDeletePlanTierTrial($input: AdminDeletePlanTierTrialInput!) {
    adminDeletePlanTierTrial(input: $input) {
      adminVenue {
        id
        activePlanTierTrial {
          ...VenueTierTrialFields
        }
        planTierTrialHistory {
          ...VenueTierTrialFields
        }
      }
      errors {
        message
      }
    }
  }
  ${venueTierTrialFragment}
`;
